import { useIntl } from 'react-intl';
import { MdOutlineError } from 'react-icons/md';
import StudentPassWarning from 'src/models/StudentPassWarning';

interface StudentPassWarningIconProps {
  warning: StudentPassWarning | null;
}

export default function StudentPassWarningIcon({ warning }: StudentPassWarningIconProps) {
  const { formatMessage } = useIntl();
  if (!warning) return null;
  return (
    <MdOutlineError
      role="img"
      aria-label={formatMessage({ id: 'studentPassWarningIconLabel' })}
      className="text-secondary text-lg ml-2"
    />
  );
}
